import { render, staticRenderFns } from "./TabItem.vue?vue&type=template&id=5ef3fef4&scoped=true"
import script from "./TabItem.vue?vue&type=script&lang=js"
export * from "./TabItem.vue?vue&type=script&lang=js"
import style0 from "./TabItem.vue?vue&type=style&index=0&id=5ef3fef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef3fef4",
  null
  
)

export default component.exports